module.exports = __webpack_public_path__ + "34bc775d/img/pdf-icon.79f04a36.svg";